import { Injectable } from '@angular/core';
import { GeneralPackageType, GeneralPackageTypeData } from '../../../interfaces/masters/generalpackagetype';
import { Observable } from 'rxjs';
import { Generalpackagetypeapi } from '../api/generalpackagetype.api';

@Injectable({
  providedIn: 'root'
})

@Injectable()
export class GeneralpackagetypeService extends GeneralPackageTypeData {

  constructor(private api: Generalpackagetypeapi) {
    super();
   }
   list(url: string): Observable<GeneralPackageType[]> {  
    return this.api.list(url);
  }

  listStorageMst(url: string,tenantId:string,branchId:string): Observable<any[]> {  
    return this.api.listStorageMst(url,tenantId,branchId);
  }

  listStorageMstById(url: string,id:string): Observable<any[]> {  
    return this.api.listStorageMstById(url,id);
  }

  create(url: string, data:GeneralPackageType): Observable<GeneralPackageType[]> {
    return this.api.add(url,data);
  }

  createStorageMst(url: string, data:any): Observable<any[]> {
    return this.api.addStorageMst(url,data);
  }

  update(url: string, data:GeneralPackageType): Observable<GeneralPackageType> {
    return this.api.update(url,data);
  }

  updateStorageMstById(url: string,id:number, data:any): Observable<any[]> {
    return this.api.updateStorageMstById(url,id,data);
  }

  listStickerDet(url: string,forWhich:string,refNo:string,admId:number): Observable<any[]> {
    return this.api.listStickerDet(url,forWhich,refNo,admId);
  }

  listAbhaDet(url: string,valueSet:string): Observable<any[]> {
    return this.api.listAbhaDet(url,valueSet);
  }
}
